let config = {
  firebaseUrl: 'https://rchat-prod.firebaseio.com',
  hostUrl: 'https://rchat-prod.firebaseapp.com',
  googleApiKey: 'AIzaSyB6bUg0mHgyDpRyrdd45Sg0-VldTaXaSVs',
  dependencies: [
    {type: 'script', url: 'https://cdnjs.cloudflare.com/ajax/libs/react/0.14.7/react.js'},
    {type: 'script', url: 'https://cdnjs.cloudflare.com/ajax/libs/react/0.14.7/react-dom.js'},
    {type: 'script', url: 'https://js.stripe.com/v2/stripe.js'},
    {type: 'script', url: 'https://cdn.firebase.com/js/client/2.4.2/firebase.js'},
    {type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.auth.min.js'}
  ],
  modules: {
    ui: {
      paths: [
        {type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.ui.min.js'},
        {type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.ui.min.css'}
      ]
    },
    embeds: {
      paths: [
        {type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.embeds.min.js'},
        {type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.embeds.min.css'}
      ]
    },
    admin: {
      paths: [
        {type: 'script', url: 'https://rchat-prod.firebaseapp.com/rchat.admin.min.js'},
        {type: 'style', url: 'https://rchat-prod.firebaseapp.com/rchat.admin.min.css'}
      ]
    }
  }
}

export default config




/** WEBPACK FOOTER **
 ** ./modules/shared/config/dev.js
 **/